import { decodeURLSafe, encodeURLSafe } from '@stablelib/base64';
export function bytesToBase64(bytes) {
    return encodeURLSafe(bytes).replace(/=/g, '');
}
export function bytesFromBase64(base64) {
    return decodeURLSafe(base64);
}
export function jsonStringifyToBase64(t) {
    const json = JSON.stringify(t);
    const byteArray = new TextEncoder().encode(json);
    return bytesToBase64(byteArray);
}
export function jsonParseFromBase64(serialized) {
    const byteArray = decodeURLSafe(serialized);
    const json = new TextDecoder().decode(byteArray);
    return JSON.parse(json);
}
//# sourceMappingURL=bytes-utils.js.map